import { Component, Input, OnInit } from '@angular/core';
import {
	Label,
	LanguageService,
	StorageService,
	TempKey,
} from '@services/public';
import { ABSTRACT_PAGE, AbstractData } from '../common';

const PAGE_PATH: string = 'skillBuilders.abstract.pages.negativeImpact';

@Component({
	selector: 'app-member-skill-builder-abstract-negative-impact',
	templateUrl: './negative-impact.component.html',
	styleUrls: ['./negative-impact.component.scss'],
})
export class MemberSkillBuilderAbstractNegativeImpactComponent
	implements OnInit
{
	@Input() data: AbstractData;
	extremeTitles: Array<string> = [];
	bigTitles: Array<string> = [];
	submitted: boolean = false;

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
		subtitle: '',
		howNegative: '',
		extremeTitle: '',
		neutral: '',
		veryNegative: '',
		howBig: '',
		bigTitle: '',
		small: '',
		large: '',
	};
	labels: { [key: string]: string } = {
		[Label.NEXT]: '',
	};

	constructor(
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page) {
				switch (key) {
					case 'extremeTitle':
						for (let i: number = 0; i < this.data.negativeReasons.length; i++) {
							this._languageSvc
								.template(this.page[key], {
									reason: this.data.negativeReasons[i].display,
								})
								.then((value) => {
									this.extremeTitles[i] = value;
								});
						}
						break;
					case 'bigTitle':
						for (let i: number = 0; i < this.data.negativeReasons.length; i++) {
							this._languageSvc
								.template(this.page[key], {
									reason: this.data.negativeReasons[i].display,
								})
								.then((value) => {
									this.bigTitles[i] = value;
								});
						}
						break;
					default:
						this._languageSvc.template(this.page[key]).then((value) => {
							this.page[key] = value;
						});
				}
			}
		});
		this._languageSvc.getLabels(this.labels);
	}

	onChange(index: number, key: 'extreme' | 'big', value: number) {
		this.data.negativeReasons[index][key] = value;
	}

	nextOnClick(): void {
		this.submitted = true;
		for (const reason of this.data.negativeReasons) {
			if (!reason.extreme || !reason.big) return;
		}
		this._storageSvc.setTempStorage(TempKey.ABSTRACT, {
			...this.data,
			page: ABSTRACT_PAGE.RATING,
		});
	}
}
